<design-slide-up-card #card [isCardOpen]="!!isCardOpen" class="route-planning-results" [showLogoInHeader]="true"
  [showBackgroundImage]="true" [title]="routePlanningText" [hideHeaderInDesktop]="true" [class]="direction">
  <app-results-header (onBackClick)="closeCard()">
    <ng-container buttons>
      <mot-button type="button" icon="share-nodes" buttonClass="!text-white !bg-transparent" iconClass="text-2xl" [text]="shareText"
        (onClick)="shareResults()" ariaHaspopup="dialog" />

        <mot-menu [menuVert]="false" [menuItems]="moreActionsMenuItems" [menuButtonAriaLabel]="moreActionsMenuText" dir="rtl"
          buttonClass="!rounded-xl !text-white !bg-transparent !w-8 !h-8 !min-w-0"
          buttonActiveClass="!rounded-xl !bg-white !w-8 !h-8 !min-w-0 !text-[#0C3058]"
          heightClass="!h-[4rem]"
          />
        </ng-container>

        <app-addresses-details content [origin]="formValues.origin.cityName"
          [destination]="formValues.destination.cityName"
          [asRouteSummaryHeading]="true" />
        </app-results-header>

        <div class="flex-1 overflow-y-auto rounded-t-xl bg-white use-scrollbar" (scroll)="onScroll($event)" id="printableArea" [class]="direction">
          @if (!!results && !!results.length) {
            <app-lines-between-cities-results-list [results]="results" (onResultClick)="handleResultClick($event)" />
          } @else {
            <app-no-results [noResultsForWhatText]="noResultsForText" />
          }

        </div>
      </design-slide-up-card>
      @if (isLoadingMoreData) {
        <app-loader/>
      }
